import React, { useEffect } from "react";
import { ErrorOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { fetchMeta } from "../../actions/metaActions";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import "./OrderError.css"; 

export default function OrderError() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { meta, loading: metaLoading } = useSelector((state) => state.metaState);

    useEffect(() => {
        dispatch(fetchMeta('order-error'));
    }, [dispatch]);
    return (
        <>
            <Helmet>
                <title>{meta?.title}</title>
                <meta name="description" content={meta?.metaDescription} />
                <meta name="keywords" content={meta?.keywords} />
                <link rel="canonical" href={meta?.canonicalUrl} />
                <meta name="robots" content={meta?.robots} />
            </Helmet>

            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="empty-cart text-center py-5">
                    <ErrorOutline className="error-icon" />
                    <h2 className="error-title">Oops! Something went wrong</h2>
                    <p className="error-message">
                        There was an error processing your request. Please try again later.
                    </p>
                    <button
                        className="error-btn"
                        onClick={() => navigate("/")}
                    >
                        Go Back Home
                    </button>
                </div>
            </div>
        </>
    );
}
